import { useState } from 'react';
import { Form, Formik } from 'formik';

import CTAButton from './CTAButton';
import StickyInput from './StickyInput';
import { emailRegex } from '../consts';

interface UserVerificationProps {
  defaultValue?: string;
  defaultLabel?: string;
  buttonText: string;
  loading: boolean;
  onSubmit: (contact: string, type: string) => void;
}

export default function UserVerification({
  defaultValue = '',
  defaultLabel = 'Email or Phone Number',
  buttonText = 'Next',
  loading = false,
  onSubmit,
}: UserVerificationProps) {
  const [valid, setValid] = useState(false);
  const [label, setLabel] = useState(defaultLabel);

  function detectInputType(value: string) {
    const phoneRegex = /^\d{1,7}$/;
    const emailRegex = /^[a-zA-Z0-9._-]{0,4}$/;

    const val = value.replace(/[\W]/g, '').slice(0, 4);
    if (val && phoneRegex.test(val) && !value.includes('@') && !value.includes('.')) {
      setLabel('Phone Number');
      return 'phone';
    } else if (val && emailRegex.test(val.toLowerCase())) {
      setLabel('Email');
      return 'email';
    }
    setLabel(defaultLabel);
    return 'unknown';
  }

  return (
    <Formik
      initialValues={{
        contact: defaultValue,
      }}
      onSubmit={(values) => {
        const contact = values.contact;
        onSubmit(contact, detectInputType(contact));
      }}
    >
      <Form>
        <div className="mb-12">
          <StickyInput
            id="contact"
            name="contact"
            type="text"
            placeholder={label}
            mask={[
              { ckType: 'unknown', mask: '**********' },
              {
                ckType: 'phone',
                mask: '(999) 999-9999',
                definitions: { 9: /\d/ },
              },
              { ckType: 'email', mask: /^\S*@?\S*$/gm },
            ]}
            dispatch={(appended: any, masked: any, flags: any) => {
              const typed = `${masked.value}${appended}`;
              const newMask = masked.compiledMasks.find((m: any) => {
                return m.ckType === detectInputType(typed);
              });

              if (newMask.ckType === 'email') {
                setValid(emailRegex.test(typed));
              } else {
                setValid(newMask.isComplete);
              }
              return newMask;
            }}
          />
        </div>
        <CTAButton
          ariaLabel="signin"
          text={buttonText}
          icon={['far', 'lock']}
          disabled={!valid}
          loading={loading}
        />
      </Form>
    </Formik>
  );
}
